export default __webpack_public_path__ + "static/media/Gold.514624a6.svg";